import { formatDealValue } from './privateEventDisplay';

/** The deal figure, visibly an estimate and never styled like workshop revenue. */
export default function DealValue({ cents }: { cents: number | null }) {
  if (cents === null) {
    return <span style={{ fontStyle: 'italic', color: 'var(--nb-faint)' }}>Not set</span>;
  }
  return (
    <span
      title="Reference figure typed by the RD. No money moves through Nebari for private events."
      style={{ display: 'inline-flex', alignItems: 'baseline', gap: 6, whiteSpace: 'nowrap' }}
    >
      <span
        className="nb-tabular"
        style={{
          fontSize: 14,
          fontWeight: 600,
          color: 'var(--nb-muted)',
          borderBottom: '1px dashed var(--nb-border-2)',
        }}
      >
        ≈ {formatDealValue(cents)}
      </span>
      <span
        style={{
          fontSize: 9.5,
          fontWeight: 700,
          letterSpacing: '.05em',
          textTransform: 'uppercase',
          color: 'var(--nb-subtle)',
          border: '1px solid var(--nb-border-2)',
          borderRadius: 999,
          padding: '0 6px',
        }}
      >
        estimate
      </span>
    </span>
  );
}
